import actions from './actions';
import mutations from './mutations';
import getters from './getters';

const state = () => ({
  brandsReport: [],
  clientsReport: [],
  finantialReport: {},
  pendingBillsReport: {},
  sparePartsReport: [],
  serviceReport: [],
  subServiceReport: [],
  ordersReport: {},
  sparePartTrendReport: {},
  workersReport: [],
  workerPendingWorkReport: null,
  workerCommissionReport: null,
  debtorsReport: [],
  unpickedOrdersReport: [],
  weeklyWorkReport: null
});

export default {
  namespaced: true,
  state,
  actions,
  mutations,
  getters
};
